<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索条件：
                        <el-input size="mini" placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select size="mini" v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option v-for="item in keywordList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV"> <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true" /> </el-button>
                </div>
            </div>
            <div v-show="showFV" >
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>支付渠道：
                        <el-select clearable v-model="searchVal.payWayCode" placeholder="支付渠道" size="mini" style="width: 120px;margin-right: 15px;">
                            <el-option v-for="item in this._enums.PayWayEnum" :key="item.id" :label="item.name" :value="item.id"/>
                        </el-select>
                    </div>
                    <div>
                        支付方式：
                        <el-select clearable v-model="searchVal.payModeCode" placeholder="支付方式" size="mini" style="width: 120px;margin-right: 15px;">
                            <el-option v-for="item in this._enums.PayModeEnum" :key="item.id" :label="item.name" :value="item.id"/>
                        </el-select>
                    </div>
                    <div>
                        金额范围：
                        <el-input v-model="searchVal.minAmount" size="mini" clearable style="width: 160px;margin-right: 0px;">
                            <span slot="append">元</span>
                        </el-input>
                        -
                        <el-input v-model="searchVal.maxAmount" size="mini" clearable style="width: 160px;margin-right: 15px;">
                            <span slot="append">元</span>
                        </el-input>
                    </div>
                </div>
                <div class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>交易日期： <el-date-picker v-model="searchVal.transDateScope" value-format="yyyy-MM-dd" style="width:250px;margin-right: 15px;" type="daterange" size="mini" unlink-panels start-placeholder="开始日期" range-separator="至" end-placeholder="结束日期" /></div>
                    <div>
                        汇总条件：<el-select @change="searchDo" multiple clearable v-model="searchVal.totalTypes" placeholder="请选择汇总条件" size="mini" style="width: 350px;margin-right: 15px;">
                        <el-option
                                v-for="item in this._enums.MchTotalTypeEnum"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    </div>
                </div>
            </div>
        </div>
        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="jnl"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="mchInfo.mchName" label="商户名称" width="100"  show-overflow-tooltip />
                <el-table-column prop="mchInfo.shortName" label="商户简称" width="100" show-overflow-tooltip />
                <el-table-column prop="mchInfo.mchNo" label="商户号" width="100"  />
                <el-table-column prop="agentName" label="服务商" width="100" show-overflow-tooltip />
                <el-table-column prop="mchInfo.salesmanName" label="客户经理" width="80" show-overflow-tooltip />
                <el-table-column prop="terNo" label="设备SN" align="center" width="110" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.MchTotalTypeEnum.终端.id)" />
                <el-table-column prop="payWayCode" label="支付渠道" align="center" width="80" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.MchTotalTypeEnum.支付渠道.id)" >
                    <template slot-scope="scope">
                        {{_enums.PayWayEnum.getNameById(scope.row.payWayCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="payModeCode" label="支付方式" align="center" width="80" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.MchTotalTypeEnum.支付方式.id)" >
                    <template slot-scope="scope">
                        {{_enums.PayModeEnum.getNameById(scope.row.payModeCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="paySuccTime" label="交易日期" align="center" width="90" :formatter="funDateFormatter" v-if="-1!==searchVal.totalTypes.indexOf(this._enums.MchTotalTypeEnum.交易日期.id)" />
                <el-table-column prop="amount" label="交易金额" align="right" :formatter="funFmtTransAmt" sortable/>
                <!--
                <el-table-column prop="amount" label="手续费" align="right" :formatter="funFmtTemp" />
                <el-table-column prop="amount" label="实拨金额" align="right" :formatter="funFmtTransAmt" />
                -->
                <el-table-column prop="cnt" label="交易笔数" align="center" width="120" sortable />
            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="height:32px;line-height: 32px; font-family: 'Arial Black'; font-size: 15px; background-color:green; color: white; padding-left: 15px;padding-right: 15px; ">{{msgInfo}}</div>
            <div class="yx-flex-h-end">
                <el-pagination
                        :current-page.sync="page"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev,pager,next, jumper,->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "RptMchTraTot",
        data() {
            return {
                loading: false,
                showFV: false,
                total: 0,
                msgInfo: 0,
                page: 1,
                size: 10,
                jnl: [],
                keywordList: [
                    {id:"mchInfo.mchName",name:"商户名称"},
                    {id:"mchInfo.shortName",name:"商户简称"},
                    {id:"mchInfo.salesmanName",name:"客户经理名称"},
                ],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    totalTypes : [],
                    mchInfo: {
                        agentId: null,
                        salesmanId: null,
                        mchNo: null,
                        status: null,
                        mchName: null,
                        shortName: null,
                        salesmanName: null,
                        agentName: null,
                        outMchNo: null,
                        createWay: null
                    },
                    mchNo : null,
                    terNo : null,
                    payWayCode : null,
                    payModeCode : null,
                    transDateScope : null,
                    minAmount: null,
                    maxAmount: null
                },
            }
        },
        mounted() {
            this.initJnl();
        },
        methods: {
            searchReset() {
                this.searchVal = {};
                this.searchVal.totalTypes = [];
            },
            searchDo() {
                this.page = 1;
                this.initJnl();
            },
            initJnl() {
                this.loading = true;
                let url = '/rpt/agent/mch/transTotals/?page=' + this.page + '&size=' + this.size;
                if (this.searchVal.totalTypes)
                    url += '&totalTypes=' + this.searchVal.totalTypes;
                if (this.searchVal.keywordMethod && this.searchVal.keyword)
                    url += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                if (this.searchVal.mchNo)
                    url += '&mchInfo.mchNo=' + this.searchVal.mchNo;
                if (this.searchVal.terNo)
                    url += '&terNo=' + this.searchVal.terNo;
                if (this.searchVal.payWayCode)
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                if (this.searchVal.payModeCode)
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                if (this.searchVal.transDateScope)
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                if (this.searchVal.minAmount)
                    url += '&minAmount=' + this.searchVal.minAmount;
                if (this.searchVal.maxAmount)
                    url += '&maxAmount=' + this.searchVal.maxAmount;

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.jnl = resp.data;
                        this.total = resp.total;
                        this.msgInfo = resp.msgInfo;
                    }
                });
            },
            exportData() {
                window.open('/bill/export', '_parent');
            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            funFmtCnt(row, column) {
                return parseInt(row.cnt)+1;
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initJnl();
            },
        }
    }
</script>

<style>

</style>
